// Google Calendar one-tap links + .ics export — no API keys required.

function pad(n) { return String(n).padStart(2, "0"); }

function ymd(dateStr) {
  // dateStr "YYYY-MM-DD" -> "YYYYMMDD"
  return (dateStr || "").replaceAll("-", "");
}

function nextDay(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  d.setDate(d.getDate() + 1);
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
}

export function googleCalUrl(ev, label) {
  if (!ev.date) return null;
  const start = ymd(ev.date);
  const end = nextDay(ev.date);
  const title = `${ev.title}${label ? ` (${label})` : ""}`;
  const details = [ev.description, ev.type ? `Type: ${ev.type}` : "", "Added via Syllabify"]
    .filter(Boolean).join("\n");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${start}/${end}`,
    details,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

function escapeICS(s = "") {
  return String(s).replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
}

export function buildICS(events, courseLabelFor) {
  const now = new Date();
  const stamp = `${now.getUTCFullYear()}${pad(now.getUTCMonth() + 1)}${pad(now.getUTCDate())}T${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}${pad(now.getUTCSeconds())}Z`;
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Syllabify//Semester Planner//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "X-WR-CALNAME:Syllabify Deadlines",
  ];
  events.filter((e) => e.date).forEach((e) => {
    const label = courseLabelFor ? courseLabelFor(e) : "";
    lines.push(
      "BEGIN:VEVENT",
      `UID:${e.event_id || Math.random().toString(36).slice(2)}@syllabify`,
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${ymd(e.date)}`,
      `DTEND;VALUE=DATE:${nextDay(e.date)}`,
      `SUMMARY:${escapeICS(`${e.title}${label ? ` (${label})` : ""}`)}`,
      `DESCRIPTION:${escapeICS([e.description, e.type ? `Type: ${e.type}` : ""].filter(Boolean).join(" — "))}`,
      "END:VEVENT",
    );
  });
  lines.push("END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadICS(events, courseLabelFor, filename = "syllabify-deadlines.ics") {
  const ics = buildICS(events, courseLabelFor);
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
